export default __webpack_public_path__ + "static/honda-motorcycle-logo-6de51a9d663f3e47da6c210065f93fea.png";